/* eslint-disable react-hooks/rules-of-hooks */
import { decodeToken } from 'react-jwt';
 
import axiosServices from '../../utils/axios';
const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = decodeToken(accessToken);
    if (!decoded) {
      return false;
    }

    if (decoded.MobileAssistanceUserId) {
      localStorage.setItem('idSupplier', decoded.MobileAssistanceUserId);
    }

    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

const setSession = (accessToken) => {
  if (accessToken) { 
    localStorage.setItem('supplierToken', accessToken);
    localStorage.setItem('auth', true);
    
    try {
      const decoded = decodeToken(accessToken);
      if (decoded && decoded.MobileAssistanceUserId) {
        localStorage.setItem('idSupplier', decoded.MobileAssistanceUserId);
      }
    } catch (error) {
      console.error('Token decode error:', error);
    }

    axiosServices.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('supplierToken');
    localStorage.removeItem('idSupplier');
    localStorage.removeItem('auth');
    delete axiosServices.defaults.headers.common.Authorization; 
  }
};
 
const sign = (payload, privateKey, header) => {
  const now = new Date();
  header.expiresIn = new Date(now.getTime() + header.expiresIn);
  const encodedHeader = btoa(JSON.stringify(header));
  const encodedPayload = btoa(JSON.stringify(payload));
  const signature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)),
      )
      .join(''),
  );

  return `${encodedHeader}.${encodedPayload}.${signature}`;
};

const verify = (token) => {
  if (!token) {
    return false;
  }

  try {
    return isValidToken(token);
  } catch (error) {
    console.error('Token verification error:', error);
    return false;
  }
};

export { isValidToken, setSession, sign, verify };
